import { renderReact } from "hypernova-react";
import BurgerMenu from "web/react/components/burger-menu/burger-menu";
import CookieBannerVariation from "web/react/components/cookie-banner/cookie-banner-variation";
import DesignerExitTrigger from "web/react/components/designer-exit-trigger/designer-exit-trigger";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import FBProductLandingOverlay from "web/react/components/fb-product-landing-overlay/fb-product-landing-overlay";
import FeedsShowMoreContainer from "web/react/components/feeds-show-more-container/feeds-show-more-container";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FilterContainer from "web/react/components/filter-container/filter-container";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import Hint from "web/react/components/hint/hint";
import HomepageOverlay from "web/react/components/homepage-overlay/homepage-overlay";
import ProductArea from "web/react/components/product-area/product-area";
import ProductGallery from "web/react/components/product-gallery/product-gallery";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import RelatedProductsRails from "web/react/components/related-products-rails/related-products-rails";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import RetailerPromotionHub from "web/react/components/retailer-promotion-hub/retailer-promotion-hub";
import SearchButton from "web/react/components/search-button/search-button";
import ProductPage from "web/react/pages/product/in-stock/in-stock";
import OOSProductPage from "web/react/pages/product/out-of-stock/out-of-stock";
import withRedux from "web/react/redux-provider";
import ExpressCheckoutProductPage from "web/react/components/express-checkout-product-page/express-checkout-product-page";

export function initialiseReact(): void {
    renderReact("BurgerMenu.jsx", BurgerMenu);
    renderReact("CookieBannerVariation.jsx", CookieBannerVariation);
    renderReact("DesignerExitTrigger.jsx", DesignerExitTrigger);
    renderReact("EmailCaptureOverlay.jsx", EmailCaptureOverlay);
    renderReact("FBProductLandingOverlay.jsx", FBProductLandingOverlay);
    renderReact("FeedsSeoContent.jsx", FeedsSeoContent);
    renderReact("FilterContainer.jsx", withRedux(FilterContainer));
    renderReact("FeedsShowMoreContainer.jsx", withRedux(FeedsShowMoreContainer));
    renderReact("FollowStickyBanner.jsx", FollowStickyBanner);
    renderReact("Hint.jsx", Hint);
    renderReact("HomepageOverlay.jsx", HomepageOverlay);
    renderReact("OOSProductPage.jsx", OOSProductPage);
    renderReact("ProductArea.jsx", withRedux(ProductArea as any)); // TODO: ProductArea's proptypes are broken
    renderReact("ProductGallery.jsx", ProductGallery);
    renderReact("ProductPage.jsx", ProductPage);
    renderReact("RecentlyViewedEmailCapture.jsx", RecentlyViewedEmailCapture);
    renderReact("RelatedProductsRails.jsx", RelatedProductsRails);
    renderReact("RetailerPromotionHub.jsx", RetailerPromotionHub);
    renderReact("SearchButton.jsx", SearchButton);
    renderReact("RelatedSearchesRail.jsx", RelatedSearchesRail);
    renderReact("ExpressCheckoutProductPage.jsx", ExpressCheckoutProductPage);
}
